import PropTypes from "prop-types"

import colors from "foundation/_colors_export.scss?variables"

export default function TableIcon({ fill, height, width, onClick }) {
  return (
    <svg
      version="1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 56 56"
      onClick={onClick}
    >
      <path
        d="M0 28v28h56V0H0v28zm33-17v5H6V6h27v5zm17 17v22H40V6h10v22zm-17 0v5H6V23h27v5zm0 17v5H6V40h27v5z"
        fill={fill}
      />
    </svg>
  )
}

TableIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  onClick: PropTypes.func,
}

TableIcon.defaultProps = {
  fill: colors.primaryTextColor,
  width: "32",
  height: "32",
}
